module.exports = __webpack_public_path__ + "img/pet_happy_2.6da71cd8.svg";